import { SEPARATOR } from 'enums'
import { isEmpty } from 'lodash'

export const isSvg = url => {
  if (!url) {
    return false
  }
  const urlArr = url?.split(SEPARATOR.DOT)
  if (!isEmpty(urlArr)) return urlArr.at(-1) === 'svg'
  return false
}
